import React from "react";

const SiteContext = React.createContext({
  siteId: "",
  setSiteId: () => {},
  isPaid: false,
  setIsPaid: () => {},
  isTrialStarted: false,
  setIsTrialStarted: () => {},
  isExpired: false,
  setIsExpired: () => {},
  faireProductSync: "",
  setFaireProductSync: () => {},
  faireOrderSync: "",
  setFaireOrderSync: () => {},
  wixProductSync: "",
  setWixProductSync: () => {},
});

export default SiteContext;
